import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import StakeholdersFieldCst from "@components/StakeholdersFieldCst";
import { WizardStepProps } from "@components/WizardCst/types";
import { MediaType } from "src/interfaces/Media";
import { ActivityWizardData } from "../../../types";
import { isFieldVisible } from "../config/additionalInfoConfig";
import SectionHeader from "./SectionHeader";
import MultiAssociationField from "./MultiAssociationField";
import UsefulLinksField from "./UsefulLinksField";

const ToolsSection: React.FC<WizardStepProps<ActivityWizardData>> = ({
  data,
  setData,
  errors,
}) => {
  const { t } = useTranslation("wizard-activity");
  const { t: tPicker } = useTranslation("media-library-picker");

  const showMaterials = isFieldVisible(
    "didactical_material",
    data.type,
    data.is_standalone,
  );
  const showStakeholders = isFieldVisible(
    "stakeholders",
    data.type,
    data.is_standalone,
  );

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <SectionHeader
        title={t("sections.tools.title")}
        description={t("sections.tools.description") || undefined}
      />

      {showMaterials && (
        <MultiAssociationField
          label={t("fields.didactical-material")}
          values={data.didactical_material}
          onChange={(next) => setData({ didactical_material: next })}
          addLabel={t("common.add") || "Aggiungi"}
          emptyLabel={
            t("common.empty-didactical-material") ||
            "Nessun materiale didattico aggiunto"
          }
          emptyVariant="card"
          mediaType={MediaType.DIDACTICAL_MATERIAL}
          pickerTitle={tPicker("title-material") || ""}
        />
      )}

      <UsefulLinksField
        values={data.useful_links}
        onChange={(next) => setData({ useful_links: next })}
        errors={errors}
      />

      {showStakeholders && (
        <StakeholdersFieldCst
          title={t("sections.stakeholders.title")}
          description={t("sections.stakeholders.description") || undefined}
          addLabel={t("common.add") || "Aggiungi"}
          values={data.stakeholders || []}
          onChange={(next) => setData({ stakeholders: next })}
        />
      )}
    </Box>
  );
};

export default ToolsSection;
